/**
 * Glass confirm — Promise-based replacement for window.confirm.
 * One overlay at a time; Esc / Cancel → false; Confirm → true.
 */

export function softConfirm(message, opts = {}) {
  const text = String(message || "Continue?").trim() || "Continue?";
  const confirmLabel = String(opts.confirmLabel || "Confirm");
  const cancelLabel = String(opts.cancelLabel || "Cancel");
  const danger = !!opts.danger;

  return new Promise((resolve) => {
    const existing = document.getElementById("dsSoftConfirm");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.id = "dsSoftConfirm";
    overlay.className = "modal-overlay ds-soft-confirm-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML = `
      <div class="modal glass-panel glass-panel--panel ds-soft-confirm-card ds-dialog" role="document">
        <div class="modal-head">
          <p class="incident-workspace__eyebrow" style="margin:0">Confirm</p>
          <h3 class="ds-soft-confirm-title" style="margin:4px 0 0;font-size:17px;font-weight:650">Take action</h3>
        </div>
        <div class="modal-body">
          <p class="ds-soft-confirm-msg"></p>
        </div>
        <div class="modal-foot row" style="justify-content:flex-end;gap:12px">
          <button type="button" class="btn secondary sm btn-tap" data-soft-confirm="0">${cancelLabel.replace(/</g, "&lt;")}</button>
          <button type="button" class="btn sm ${danger ? "danger" : ""} btn-tap" data-soft-confirm="1">${confirmLabel.replace(/</g, "&lt;")}</button>
        </div>
      </div>`;
    const msgEl = overlay.querySelector(".ds-soft-confirm-msg");
    if (msgEl) msgEl.textContent = text;

    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      document.removeEventListener("keydown", onKey, true);
      overlay.remove();
      resolve(!!ok);
    };
    const onKey = (ev) => {
      if (ev.key === "Escape") {
        ev.preventDefault();
        finish(false);
      } else if (ev.key === "Enter") {
        const t = ev.target;
        if (t && (t.tagName === "TEXTAREA" || t.tagName === "INPUT")) return;
        ev.preventDefault();
        finish(true);
      }
    };
    overlay.addEventListener("click", (ev) => {
      if (ev.target === overlay) finish(false);
      const btn = ev.target && ev.target.closest ? ev.target.closest("[data-soft-confirm]") : null;
      if (!btn) return;
      finish(btn.getAttribute("data-soft-confirm") === "1");
    });
    document.addEventListener("keydown", onKey, true);
    document.body.appendChild(overlay);
    requestAnimationFrame(() => {
      try {
        overlay.classList.add("is-open");
        overlay.hidden = false;
        overlay.removeAttribute("aria-hidden");
      } catch (_) {}
    });
    const primary = overlay.querySelector('[data-soft-confirm="1"]');
    if (primary && typeof primary.focus === "function") {
      try { primary.focus(); } catch (_) {}
    }
  });
}
